import { registerCapability } from '../../platform/capability-registry';
import { DnsBlock } from './DnsBlock';
import { DNS_ACTION_KEY_LIST, DNS_FIELD_KEY_LIST } from './fieldKeys';
import type { DnsBlockOptions } from './types';

registerCapability<DnsBlockOptions>({
  key: 'dns',
  fields: [...DNS_FIELD_KEY_LIST],
  actions: [...DNS_ACTION_KEY_LIST],
  component: DnsBlock,
  defaultPaths: (prefix) => ({
    nameservers: `${prefix}.dnsConfig.nameservers`,
    searches: `${prefix}.dnsConfig.searches`,
    options: `${prefix}.dnsConfig.options`,
  }),
});
